import * as React from 'react';
import { Translate } from '../../../../../../shared/LanguageService';
import history from '../../../../../../shared/history';
import BaseTab from './BaseTab';

type StylistAdminCalendarsTabProps = {
    label: string;
};

const StylingCalendarsRoute = '/stylingcalendars';

let routes = [StylingCalendarsRoute];

function StylistAdminCalendarsTab({ label, ...props }: StylistAdminCalendarsTabProps) {
    function handleClick() {
        history.push(StylingCalendarsRoute);
    }

    return <BaseTab {...props} onClick={handleClick} label={label} route={StylingCalendarsRoute} />;
}

function TranslatedStylistAdminCalendarsTab(props) {
    const label = Translate('header/nav/calendar');
    return <StylistAdminCalendarsTab {...props} label={label} />;
}

TranslatedStylistAdminCalendarsTab.routes = routes;

export default TranslatedStylistAdminCalendarsTab;
